import {memoizeWith} from "ramda";

const ensureProperBasePath = (str: string) => {
    if (str.length === 0 || str[0] !== "/") {
        str = "/" + str;
    }
    if (str.length > 1 && str[str.length - 1] === "/") {
        str = str.substr(0, str.length - 1);
    }
    return str;
};

export const getBasePath = memoizeWith(
    () => "baseUrl",
    () => {
        const htmlBase = document.getElementsByTagName("base")[0]?.getAttribute("href");
        if (htmlBase) {
            return ensureProperBasePath(htmlBase);
        }
        const basePath = process.env.BASEPATH;
        if (typeof basePath === "string" && basePath) {
            return ensureProperBasePath(basePath);
        }
        const publicUrl = process.env.PUBLIC_URL;
        if (typeof publicUrl === "string" && publicUrl) {
            return ensureProperBasePath(publicUrl);
        }
        return "/";
    }
);
